module.exports = __webpack_public_path__ + "img/vera-cho-10SLUJj6G6w-unsplash.dddae0e9.jpg";